import * as types from '../actiontypes';
import env from '../../util/env';

export function getUserByGUI(engagementId, userId) {
	const url = env.getServerUrl() + 'Engagements/' + engagementId + '/Users/' + userId;

	return {
		type: types.GET_USER_BY_GUI,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}
